/* 🤖 this file was generated by svg-to-ts */
export const svgClock: {
    name: "clock";
    data: string;
} = {
    name: "clock",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__clock" viewBox="0 0 24 24"><path d="M12 5.5c-3.584 0-6.5 2.917-6.5 6.5 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-3.583-2.916-6.5-6.5-6.5zm0 12c-3.032 0-5.5-2.468-5.5-5.5S8.968 6.5 12 6.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5z"/><path d="M12.5 8h-1v4.304l2.146 2.146.708-.707L12.5 11.89"/></symbol></svg>`,
};
